import { FC, useState } from 'react';

// Third-party
import Box from '@mui/material/Box';
import Icon from '@mdi/react';
import { mdiPlusCircleOutline } from '@mdi/js';
import { useTheme } from '@mui/material';

// Redux-toolkit
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { commonActions } from '../../../../store/common/slice';
import { schedulesActions } from '../../../../store/schedules/slice';

// Hooks
import { useAppDispatch } from '../../../../hooks/useAppStore';

// Types
import { TCreateShift } from '../type';

const CreateShift: FC<TCreateShift> = ({ date, member }) => {
  const dispatch = useAppDispatch();
  const theme = useTheme() as TCustomTheme;

  const { isLight } = useCustomTheme(theme);
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseOver = () => {
    setIsHovering(true);
  };

  const handleMouseOut = () => {
    setIsHovering(false);
  };

  const openCreateShiftNav = () => {
    dispatch(commonActions.setIsOpenPagesNav(true));
    dispatch(schedulesActions.setSelectedShiftDate(date));
    dispatch(schedulesActions.setSelectedShiftMember(member));
  };

  return (
    <Box
      className="cursor-pointer"
      onMouseOut={handleMouseOut}
      onMouseOver={handleMouseOver}
      height="100%"
      width="100%"
      position="relative"
      onClick={openCreateShiftNav}
      sx={{
        '&:hover': {
          backgroundColor: 'rgba(168, 85, 247, 0.16)',
        },
      }}
    >
      {isHovering && (
      <Icon
        className="center"
        color={!isLight ? 'white' : theme.palette.primary.main}
        path={mdiPlusCircleOutline}
        size={1.2}
      />
      )}
    </Box>
  );
};

export {
  CreateShift,
};
